React = require 'react'
E = React.createElement
N = {}
{merge} = require 'lodash/object'


translations =

__ = (t) -> translations[t] || t

class Version extends React.Component
  render: ->
    E 'div', @props,
      "#{process.env.VERSION || "dev"} - © #{(new Date()).getFullYear()} WILLEMOT NV"

module.exports = Version



// WEBPACK FOOTER //
// ./components/version.coffee